<template>
  <v-container>
    <v-card class="shadowCard">
      <v-card-title primary-title>
        <span
          class="text-caption"
          style="font-size: 20px; font-weight: bold; color: #333"
        >
          Reglamento:
        </span>
      </v-card-title>
      <v-card-text>
        <ol>
          <li
            v-for="regla in filterReglas"
            :key="regla.id"
            style="font-size: 16px; color: #555"
          >
            {{ regla.regla }}
          </li>
        </ol>
      </v-card-text>
      <v-card-actions class="d-flex justify-center pt-4">
        <v-btn
          color="blue darken-1"
          class="elevation-6"
          dark
          v-show="!infoFirma.length"
          @click="showFirmaContainer = true"
          tile
        >
          <v-icon small left>mdi-pencil</v-icon>
          Firmar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-5 shadowCard" v-show="showFirmaContainer">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="nombre_tutor"
              label="Nombre del padre o tutor"
              outlined
              hide-details
              dense
            ></v-text-field>
          </v-col>
          <v-card-title primary-title>
            <span
              class="text-caption"
              style="font-size: 20px; font-weight: bold; color: #333"
            >
              Firma aquí abajo:
            </span>
          </v-card-title>
          <v-col cols="12">
            <v-card>
              <div class="wrapper">
                <canvas
                  id="signature-pad"
                  class="signature-pad"
                  :width="width"
                  :height="height"
                ></canvas>
              </div>
              <v-card-actions>
                <v-btn 
                  id="clear" 
                  @click="limpiar()"
                  color="orange"
                  small
                  tile
                  dark
                >
                  <v-icon small left>mdi-restore</v-icon>
                  Limpiar
                </v-btn>
                
                <v-spacer></v-spacer>

                <v-btn 
                  id="save-png" 
                  @click="savePNG()"
                  color="primary"
                  small
                  tile
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <Loader v-if="cargar" :loader="loader" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SignaturePad from "signature_pad";
// Dependencias
const md5 = require("md5");

// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import Loader from "@/components/alertas/Loader.vue";

export default {
  components: {
    Alerta,
    Loader,
  },

  data: () => ({
    modoVista: 1, // 1-. Editar, 2-. Guardar
    disabled: true,
    contrasenias: true,
    reglas: [],
    infoAlumno: [],
    infoFirma: [],
    curso: 0,
    signaturePad: null,
    file: "",
    showFirmaContainer: false,
    nombre_tutor: null,
    vistasPrevias: [],
    firma: null,
    bloquearBoton: false,
    encontrado: false,
    array: 0,

    // Datos del usuario
    nuevoPass: "",
    nuevoPass2: "",

    showPassword: false,
    showPassword2: false,
    rules: [
      (v) => !!v || "Requerido",
      (v) => (v && v.length >= 7) || "Debes ingresar más de 8 caractéres",
    ],

    respuestaAlerta: false,
    success: false,

    loader: true,
    cargar: false,
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },
  }),

  mounted() {
    let canvas = document.getElementById("signature-pad");
    this.signaturePad = new SignaturePad(canvas);
    // this.bloquearBoton = (1 === 1);
  },

  computed: {
    ...mapGetters("login", ["getUsuarioLMS", "getDatosUsuarioLMS"]),

    filterReglas() {
      if (this.curso) {
        return this.reglas.filter((el) => {
          return el.idcurso == this.curso;
        });
      } else {
        return this.reglas;
      }
    },

    width() {
      return this.$vuetify.breakpoint.width - 1400;
    },
    height() {
      return this.$vuetify.breakpoint.height - 1000;
    },

  },

  created() {
    this.initialize();
    this.getInfoAlumno();
    this.getInfoFirma();

  },

  methods: {
    ...mapActions("login", ["grabarUsuario", "grabarDatosUsuario"]),

    validarDatos() {
      return this.$refs.form.validate();
    },

    initialize() {
      this.cargar = true;
      this.reglas = [];
      this.$http
        .get("reglamento.get.reglamento")
        .then((response) => {
          this.reglas = response.body;
          this.cargar = false;
        })
        .catch((error) => {
          // INdicamos que hay un error en el back
          if (error.body.message) {
            this.error = error.body.message;
          } else {
            this.error = error.body;
          }
          this.errorBack = true;
          this.dialogError = true;
        });
    },

    getInfoAlumno() {
      this.overlay = true;
      this.infoAlumno = [];

      let payload = {
        id_alumno: this.getUsuarioLMS.id,
        id: this.getUsuarioLMS.id,
      };

      this.$http.get(`reglamento.info.alumno/${payload.id_alumno}/${payload.id}`).then((response) => {
        this.infoAlumno = response.body;
        this.curso = this.infoAlumno[0].tipo_curso;

        console.log( this.curso )
        this.overlay = false;
      })
      .catch((error) => {
        this.error = error.body;
        this.overlay = false;
      });
    },

    async savePNG() {
      //   alert(this.signaturePad.isEmpty());

      let url = this.signaturePad.toDataURL();

      // Archivo blob binario
      let blobBin = atob(url.split(",")[1]);
      let array = [];
      // Recorremos el resultado
      for (let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
      }

      // Convertimos a bloc
      const file = new Blob([new Uint8Array(array)], { type: "image/png" });
      // Lo convertimos a archivo para poder agregarle una imagen
      const file2 = new File([file], "imagen.png", { type: "image/png" });

      // Creamos el documento
      let formData = new FormData();
      // agregamos el documento
      formData.append("file", file2);

      // Guardamos el documento
      //   this.$http.post("imagen-contrato", formData).then((response) => {
      //   });
      return new Promise((resolve, reject) => {
        // obtener la extensión del archivo
        // Hacemos la petición
        this.$http
          .post(`firma.add_archivo`, formData)
          .then((response) => {
            resolve(response);
            this.firma = response.body.nombre;

            let payload = {
              idusuario: this.getUsuarioLMS.id,
              nombre_tutor: this.nombre_tutor,
              firma_tutor: this.firma,
            };

            this.$http
              .post(`add.firma`, payload)
              .then((response) => {
                resolve(response);
                this.cargar = false;
                this.parametros.mensaje = response.body.message;
                this.parametros.dialogError = true;
                this.parametros.color = "success";
                this.respuestaAlerta = true;
                this.disabled = true;
                this.limpiar();
                this.getInfoFirma()
                this.nombre_tutor = null;
                this.showFirmaContainer = false;
              })
              .catch((error) => {
                console.log("Algo paso 2", error);
              })
              .finally(() => {
                this.cargar = false;
              });
          })
          .catch((error) => {
            console.log("Algo paso 3", error);
          })
          .finally(() => {
            this.cargar = false;
          });
      });
    },

    limpiar() {
      this.signaturePad.clear();
    },

    getInfoFirma() {
      this.overlay = true;
      this.infoFirma = [];

      let payload = {
        id_alumno: this.getUsuarioLMS.id,
      };

      this.$http
        .get(`reglamento.consulta.firma/${payload.id_alumno}`)
        .then((response) => {
          this.infoFirma = response.body;
          this.overlay = false;
        })
        .catch((error) => {
          this.error = error.body;
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
.shadowCard {
  border-radius: 15px !important;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.15) !important;
}

.white-bg {
  background-color: #ffffff; /* Código de color para blanco */
}
</style>